<!-- @format -->

<manual-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <h1 class="heading-01 heading_manual">ご利用ガイド</h1>
      </li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">
    <section class="contents_area">
      <div class="contents_block detail">
        <h3 class="heading-03 margin-spacing-2_bottom">ご利用ガイド</h3>

        <ul class="file_list">
          <li class="file_list-item">
            <a
                    href="/assets/pdf/manual_price_summary.pdf"
                    class="download"
                    target="_blank"
                    onclick="{ onClick }"
            >
              支払調書関連機能についてのマニュアル（PDF）
            </a>
          </li>
        </ul>
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
<script>
  import di from "dependency-injection";
  import index from "@tags/pages/menu/help/index.riot";
  import about from "@tags/pages/menu/help/about.riot";
  import progress from "@tags/pages/menu/help/progress.riot";
  import money from "@tags/pages/menu/help/money.riot";
  import flowBusiness from "@tags/pages/menu/help/flow/business.riot";
  import flowMoney from "@tags/pages/menu/help/flow/money.riot";

  export default {
    state: {
      tag: "index"
    },
    components: {
      "index": index,
      "about": about,
      "progress": progress,
      "money": money,
      "flow-business": flowBusiness,
      "flow-money": flowMoney
    },
    onBeforeMount(props){
      const big_category = props.routeParams[0] || null;
      const small_category = props.routeParams[1] || null;
      if (!small_category) {
        this.state.tag = this.components[big_category] ? big_category : 'index';
      }else{
        this.state.tag = this.components[`${big_category}-${small_category}`] ? `${big_category}-${small_category}`: 'index';
      }
    }
  }
</script>
</manual-tag>
